import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Pipe({
    name: 'toFormGroup',
})
export class ToFormGroupPipe implements PipeTransform {
    transform(abstractControl: AbstractControl): FormGroup {
        return abstractControl as FormGroup;
    }
}
